<div class="company-user-info-card" *ngIf="!!userFormGroup">
  <div class="company-user-info-card__user">
    <company-block-card
      [title]="'LABELS.USER_INFO'"
      [hint]="isEditUser && 'LABELS.COMPANY_EDIT_PROFILE_DESCRIPTION'"
      [explanationSubTitle]="isEditUser && 'LABELS.PLEASE_FILL_USER_INFO'"
      [isMarginBottom]="true"
    >
      <ng-container card-actions>
        <div class="header-container__actions ml-3" (click)="changeIsEditUserState(true)">
          <img src="assets/icons/edit_gray.svg" />
          <span *ngIf="!(isTablet$ | async)">{{ "BUTTON.EDIT" | translate }}</span>
        </div>
      </ng-container>

      <ng-container card-body>
        <div class="info-container" *ngIf="!isEditUser; else editUser">
          <div class="info-container__item">
            <span class="label">{{ "LABELS.USER_NAME" | translate }}</span>
            <span class="value">{{ userFormGroup.get("firstName").value }} {{ userFormGroup.get("lastName").value }}</span>
          </div>
          <div class="info-container__item">
            <span class="label">{{ "LABELS.EMAIL_ADDRESS" | translate }}</span>
            <span class="value">{{ userFormGroup.get("email").value }}</span>
          </div>
          <div class="info-container__item" *ngIf="!(isTablet$ | async); else numberRowMobile">
            <span class="label">
              {{ "LABELS.MOBILE_NUMBER" | translate }}

              <div class="pr-lg-5" *ngIf="!user.phoneNumberConfirmed || isChangedPhoneNumber">
                <button
                  type="button"
                  class="btn btn-primary verify-btn"
                  [disabled]="!userFormGroup.get('phoneNumber').value"
                  (click)="openVerifyModal()"
                >
                  {{ "BUTTON.VERIFICATION_CODE" | translate }}
                </button>
              </div>
            </span>
            <span class="value">
              {{ phoneNumber }}
              <span class="pl-2" *ngIf="user.phoneNumberConfirmed && !isChangedPhoneNumber">
                <img src="assets/icons/icon_phone_verified.svg" />
              </span>
            </span>
          </div>
          <div class="info-container__item" *ngIf="!!this.userMemberRole">
            <span class="label">{{ "LABELS.ROLE" | translate }}</span>
            <span class="value">{{ memberRoleName | translate }}</span>
          </div>
        </div>
      </ng-container>
    </company-block-card>
  </div>
</div>

<ng-template #editUser>
  <form *ngIf="!!userFormGroup" [formGroup]="userFormGroup" class="user-form">
    <div class="user-form-block">
      <div class="d-flex flex-column col-12 col-lg-8 pl-0">
        <div class="form-row">
          <div class="col-12" id="control-firstName">
            <!-- firstName -->
            <app-control-wrapper
              [control]="userFormGroup.get('firstName')"
              [errors]="errors.firstName"
              [isShowHelper]="true"
              helper="FORM_HELPER.FIRST_NAME_MATCH_ID"
            >
              <label for="firstName" control-label>
                {{ "LABELS.FIRST_NAME" | translate }}
                <i class="fa fa-asterisk form-required" aria-hidden="true"></i>
              </label>
              <input
                type="text"
                [formControl]="userFormGroup.get('firstName')"
                class="form-control"
                id="firstName"
                name="firstName"
                [dropSpecialCharacters]="false"
                [patterns]="CUSTOM_MASK"
                [mask]="'N{40}'"
                [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH'"
                [maxMaskLength]="40"
                control-wrapper
              />
            </app-control-wrapper>
          </div>
          <div class="col-12" id="control-lastName">
            <!-- lastName -->
            <app-control-wrapper
              [control]="userFormGroup.get('lastName')"
              [errors]="errors.firstName"
              [isShowHelper]="true"
              helper="FORM_HELPER.LAST_NAME_MATCH_ID"
            >
              <label for="lastName" control-label>
                {{ "LABELS.LAST_NAME" | translate }}
                <i class="fa fa-asterisk form-required" aria-hidden="true"></i>
              </label>
              <input
                type="text"
                [formControl]="userFormGroup.get('lastName')"
                class="form-control"
                id="lastName"
                name="lastName"
                [dropSpecialCharacters]="false"
                [patterns]="CUSTOM_MASK"
                [mask]="'N{40}'"
                [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH'"
                [maxMaskLength]="40"
                control-wrapper
              />
            </app-control-wrapper>
          </div>
        </div>
        <div class="form-row">
          <div class="col-12" id="control-email">
            <!-- email -->
            <app-control-wrapper [control]="userFormGroup.get('email')" [errors]="errors.email" helper="FORM_HELPER.EMAIL">
              <label for="email" class="d-flex justify-content-between w-100" control-label>
                {{ "LABELS.EMAIL_ADDRESS" | translate }}
                <span class="d-lg-none">
                  <app-hint-tooltip-icon [hint]="'LABELS.COMPANY_EDIT_PROFILE_DESCRIPTION' | translate"></app-hint-tooltip-icon>
                </span>
              </label>
              <input
                type="text"
                [value]="userFormGroup.get('email').value"
                class="form-control"
                id="email"
                name="email"
                control-wrapper
                disabled
              />
            </app-control-wrapper>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block col-4 pr-0">
        <div class="user-form-block__description">
          {{ "LABELS.COMPANY_EDIT_PROFILE_DESCRIPTION" | translate }}
        </div>
      </div>
    </div>
    <div class="user-form-block">
      <div class="d-flex flex-column col-12 col-lg-8 pl-0">
        <span class="user-form-block__header">
          {{ "LABELS.PHONE_NUMBER_VERIFICATION" | translate }}

          <span class="d-lg-none">
            <app-hint-tooltip-icon [hint]="'LABELS.PHONE_NUMBER_VERIFICATION_DISCLAIMER' | translate"></app-hint-tooltip-icon>
          </span>
        </span>
        <div class="form-row">
          <div class="col-12 d-flex align-items-center flex-column flex-lg-row" id="control-phoneNumber">
            <!-- phoneNumber -->
            <div class="'flex-shrink-1 flex-grow-1 w-100'">
              <input-phone
                [fc]="userFormGroup.get('phoneNumber')"
                [errors]="errors.phoneNumber"
                [label]="'LABELS.MOBILE_NUMBER'"
                [id]="'phoneNumber'"
                [isShowConfirmed]="user.phoneNumberConfirmed && !isChangedPhoneNumber"
              ></input-phone>
            </div>

            <div class="flex-shrink-1 flex-grow-1 pl-lg-3 w-100" *ngIf="!user.phoneNumberConfirmed || isChangedPhoneNumber">
              <button
                type="button"
                class="btn btn-primary verify-btn"
                [disabled]="!userFormGroup.get('phoneNumber').value"
                (click)="openVerifyModal()"
              >
                {{ (isVerificationCodeExpired ? "BUTTON.VERIFICATION_CODE" : "BUTTON.VERIFY") | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block col-4 pr-0">
        <div class="user-form-block__description">
          {{ "LABELS.PHONE_NUMBER_VERIFICATION_DISCLAIMER" | translate }}
        </div>
      </div>
    </div>

    <!--    TODO: #8049 uncomment if we will return checkboxes-->
    <!--    <div class="user-form-block flex-column">-->
    <!--      <div class="user-from-block__checkbox custom-control custom-checkbox">-->
    <!--        <input-->
    <!--          type="checkbox"-->
    <!--          class="custom-control-input"-->
    <!--          id="monthlyNewslettersSubscriptionActivated"-->
    <!--          [formControl]="userFormGroup.get('monthlyNewslettersSubscriptionActivated')"-->
    <!--        />-->
    <!--        <label class="custom-control-label" for="monthlyNewslettersSubscriptionActivated">-->
    <!--          {{ "LABELS.SIGN_ME_UP_MONTHLY_NEWSLETTER" | translate }}-->
    <!--        </label>-->
    <!--      </div>-->
    <!--      <div class="user-from-block__checkbox custom-control custom-checkbox">-->
    <!--        <input-->
    <!--          type="checkbox"-->
    <!--          class="custom-control-input"-->
    <!--          id="advertisingMessagesSubscriptionActivated"-->
    <!--          [formControl]="userFormGroup.get('advertisingMessagesSubscriptionActivated')"-->
    <!--        />-->
    <!--        <label class="custom-control-label" for="advertisingMessagesSubscriptionActivated">-->
    <!--          {{ "LABELS.I_AGREE_TO_RECEIVE_MARKETING_INFO" | translate }}-->
    <!--        </label>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="user-form-actions">
      <button type="button" class="user-form-actions__button user-form-actions__button-secondary" (click)="changeIsEditUserState(true)">
        {{ "BUTTON.CANCEL" | translate }}
      </button>
      <button type="button" class="user-form-actions__button user-form-actions__button-primary" (click)="saveUser()">
        {{ "BUTTON.SAVE_CHANGES" | translate }}
      </button>
    </div>
  </form>
</ng-template>

<ng-template #numberRowMobile>
  <div class="info-container__item">
    <span class="label">{{ "LABELS.MOBILE_NUMBER" | translate }}</span>
    <span class="value">
      {{ phoneNumber }}
      <span class="pl-2" *ngIf="user.phoneNumberConfirmed && !isChangedPhoneNumber">
        <img src="assets/icons/icon_phone_verified.svg" />
      </span>
    </span>
    <div class="pr-lg-5 pt-2" *ngIf="!user.phoneNumberConfirmed || isChangedPhoneNumber">
      <button
        type="button"
        class="btn btn-primary verify-btn"
        [disabled]="!userFormGroup.get('phoneNumber').value"
        (click)="openVerifyModal()"
      >
        {{ "BUTTON.VERIFICATION_CODE" | translate }}
      </button>
    </div>
  </div>
</ng-template>

<app-verify-phone-number *ngIf="!!userFormGroup" [phone]="userFormGroup.get(['phoneNumber']).value"></app-verify-phone-number>
<input inputmode="decimal" [pattern]="integerInputMap.pattern" #hiddeninput [ngStyle]="{ position: 'fixed', bottom: '200vh' }" />

<missing-fields code="LABELS.USER_INFO" [canDecline]="false"></missing-fields>
